/* eslint-disable */

import moment from 'moment'
import _ from 'lodash'
import * as qm from 'src/utils/utils'
/* eslint-enable */
/**
 * ========== publication ==========
 */
export const publicationScopeFormatter = resScopes => {
  if (!resScopes || !resScopes.activeScope) {
    // console.error('publicationScopeFormatter error')
    return {}
  }
  let {allScopes, activeScope} = resScopes
  const initScope = function(scope) {
    // mock
    // if (scope.expiredTime) {
    //   scope.expiredTime = Date.now() - 16 * 24 * 60 * 60 * 1000
    // }
    const nowTime = Date.now()
    const data = {
      tryTimes: scope.quotaForTry,
      // 试用
      isTry: scope.source === 'tryForFree',
      scope: scope.scope,
      expiredTime: Number(scope.expiredTime),
      name: scope.name,
    }
    data.isPro = data.scope === 783
    // 标准版（团队）
    data.isAdvanced = data.scope === 775 || data.isPro
    // 剩余天数
    // data.remainingDay = moment(data.expiredTime).diff(moment(), 'day')
    // 时 分 秒 毫秒
    const oneDayTime = 1000 * 60 * 60 * 24
    data.remainingDay = (data.expiredTime - nowTime) / oneDayTime
    if (data.remainingDay < 1) {
      data.remainingDay = Number(data.remainingDay.toFixed(2))
    } else {
      data.remainingDay = parseInt(data.remainingDay)
    }
    // 即将到期
    data.isExpiring = data.expiredTime && data.remainingDay < 30
    // 已过期
    data.isExpired = data.expiredTime
      ? Boolean(data.expiredTime < nowTime)
      : true
    // 到期日期
    data.dueDate = data.expiredTime
      ? moment(data.expiredTime).format('YYYY 年 M 月 D 日')
      : ''
    return data
  }
  const active = initScope(activeScope)
  // 标准版（个人）
  active.standard = initScope(allScopes.find(e => e.scope === 259))
  // 标准版（团队）
  active.advanced = initScope(allScopes.find(e => e.scope === 775))
  // 已购买
  if (!active.standard.isTry && !active.standard.isExpired) {
    active.isBuy = active.standard
  }
  if (!active.advanced.isTry && !active.advanced.isExpired) {
    active.isBuy = active.advanced
  }
  // 专业版情况
  if (active.isPro && !active.isExpired) {
    delete active.isBuy
  }
  // 特殊 case1 试用标准版（团队） 且 购买了标准版（个人）
  if (active.isTry && active.isAdvanced) {
    if (!active.standard.isTry && !active.standard.isExpired) {
      // console.log('特殊 case1')
      active.case1 = true
    }
  }
  return active
}
export const publicationFormatter = publication => {
  const updatedTime = moment(publication.updatedTime).format(
    'YYYY.MM.DD HH:mm:ss',
  )
  const displayPubType = type => {
    switch (type) {
      case 'content':
        return '内容呈现'
      case 'group':
        return '互动社群'
      case 'quiz':
        return '问答游戏'
    }
  }
  return {
    scope: publicationScopeFormatter(publication.scopes),
    config: publication.config,
    id: publication.id,
    idString: publication.idString,
    publicationId: publication.id, // pub_id
    boundMina: publication.boundMina,
    appId: publication.appId,
    displayBoundMina: publication.boundMina ? '独立小程序' : '公共平台',
    name: publication.name, // 小程序名
    description: publication.description, // 描述
    logo: publication.logo, // 封面图
    logotype: publication.logotype, // 文字封面图
    cover: publication.cover, // 默认节目封面
    // 类型 @value [true, false]
    pubType: publication.pubType, // 小程序种类
    displayPubType: displayPubType(publication.pubType),
    creatorUid: publication.creatorUid, // 创建者 uid
    magazineIds: publication.magazineIds, // 小程序下面的杂志 id 列表
    status: publication.status, // [ 'reviewing', 'published' ]
    updatedTime: publication.updatedTime,
    displayUpdatedTime: updatedTime,
  }
}
export const publicationStringifier = publication => {
  return {
    name: publication.name,
    logo: publication.logoURL || publication.logo,
    description: publication.description,
    pub_type: publication.type,
  }
}
export const contentPublicationEventFormatter = function(event) {
  return event.contentPublication
}
export const contentPublicationStringifier = publication => {
  qm.log('publication', publication)
  return {
    name: '测试', // publication 名字
    config: {
      appId: '', // 小程序的 appId
      appName: '', // 小程序的名字
      appDesc: '', // 小程序的描述
      logo: '', //  小程序的 logo
      articleCopyright: '', // values: ['self']
      mark: '收藏', // 「马克」行为的文案
      overViewPageStyle: 'enable', // 是否启用 overview 页面 values: ['enable', 'disable']
      overViewPageName: '预览', // overview 页面的名称

      explorePageStyle: 'enable', // 是否启用 explore 页面 values: ['enable', 'disable']
      explorePageName: '发现', // explore 页面的名称

      profilePageStyle: 'enable', // 是否启用 profile 页面 values: ['enable', 'disable']
      profilePageName: '个人', // profile 页面的名称

      backgroundTextStyle: 'dark', // 下拉 loading 的颜色 values: ['dark', 'light']
      backgroundColor: '', // 窗口背景色 '#000000'
      navigationBackgroundColor: '', // 小程序顶部导航条的背景颜色
      navigationTextStyle: 'white', // 小程序顶部导航条的文字颜色 values: ['black', 'white']

      enableSubscribe: true, // 是否支持杂志订阅
      enableFollow: true, // 是否允许关注人
      enableReadTogether: true, // 是否支持一起读
      enablePay: true, // 是否开启付费
      enableGroup: true, // 是否开启社群
      enableNotify: true, // 是否需要发送 push
      // mock 品牌小程序
      enableUserForm: true, // 是否开启用户资料表单

      showHotPost: true, // 是否在内容 timeline 动态展示热门的 post
      groupTimelineRankType: 'markCount', // 社区 timeline 的排序方式
      mchId: '', // 小程序商户 ID
      mchSecretKey: '', // 小程序商户秘钥
    },
  }
}
/**
 * ========== libInfo ==========
 */
export const statusFormatter = status => {
  let result = {
    total: 0,
    reviewing: 0,
    rejected: 0,
    published: 0,
    display: '已通过',
    status: 'pass',
  }
  if (status) {
    result.total = status.totalNumber
    result.reviewing = status.reviewingNumber
    result.rejected = status.rejectedNumber
    result.published = status.publishedNumber
  }
  if (result.rejected > 0) {
    result.display = '有题目被拒绝'
    result.status = 'fail'
  } else if (result.reviewing > 0) {
    result.display = '题目审核中'
    result.status = 'check'
  } else {
    result.display = '全部通过'
    result.status = 'pass'
  }
  return result
}
export const libInfoFormatter = libInfo => {
  let levels = []
  for (let i = 0; i < 1; i++) {
    levels.push({name: ''})
  }
  if (libInfo.grades) {
    libInfo.grades.split(',').forEach((item, index) => {
      levels[index] = {
        name: item,
      }
    })
  }
  let onLine = libInfo.status
  let provider_id = ''
  let provider_path = ''
  if (libInfo.provider.id) {
    ;[provider_id, provider_path] = libInfo.provider.id.split('://')
  }
  /** @namespace libInfo.provider */
  return {
    admin: libInfo.admin,
    id: libInfo.id,
    name: libInfo.name, // 题库名称
    color: '#' + libInfo.color, // 题库主色调
    cover: libInfo.cover ? libInfo.cover.split('.mobi/')[1] : '', // 分享小程序卡片的图片
    coverURL: libInfo.cover || '', // 分享小程序卡片的图片
    tips: libInfo.tips || '', // 分享小程序卡片的文案
    editor: libInfo.editor, // 品牌商的名字
    logo: libInfo.logo.split('.mobi/')[1], // 题库品牌 logo，可以跟 provider_icon 一样
    logoURL: libInfo.logo, // 题库品牌 logo，可以跟 provider_icon 一样
    provider_name: libInfo.provider.name, // 题库 cover 右上角的 文案
    provider_appid: libInfo.provider.id, // 点击题库 cover 的跳转 path
    provider_id, // appId
    provider_path, // 跳转的页面路径
    provider_icon: libInfo.provider.icon
      ? libInfo.provider.icon.split('.mobi/')[1]
      : undefined, // 题库 banner icon
    provider_iconURL: libInfo.provider.icon, // 题库 banner iconURL
    levels, // 等级名,
    action: libInfo.action,
    status: statusFormatter(libInfo.questionsStat),
    onLine, // 0 下线 1 上线 2 预览
  }
}
export const stringifyLibInfo = (libId, libInfo) => {
  const levels = []
  libInfo.levels.forEach(level => {
    if (level.name !== '') {
      levels.push(level.name)
    }
  })
  let provider_appid = libInfo.provider_id
  if (libInfo.provider_path) {
    provider_appid = provider_appid + '://' + libInfo.provider_path
  }
  return {
    id: libId,
    name: libInfo.name,
    color: libInfo.color.slice(1),
    logo: libInfo.logo || libInfo.logoURL.split('mobi/')[1],
    editor: libInfo.editor,
    cover: libInfo.cover || libInfo.coverURL.split('mobi/')[1],
    tips: libInfo.tips,
    icon: libInfo.provider_icon || libInfo.provider_iconURL.split('mobi/')[1],
    provider_appid,
    provider_name: libInfo.provider_name,
    grades: levels.join(','),
    action: libInfo.action,
  }
}
export const newLibInfoStringifier = libInfo => {
  const levels = []
  libInfo.levels.forEach(level => {
    if (level.name !== '') {
      levels.push(level.name)
    }
  })
  let provider_appid = libInfo.provider_id
  if (libInfo.provider_path) {
    provider_appid = provider_appid + '://' + libInfo.provider_path
  }
  return {
    publication: libInfo.publicationId,
    name: libInfo.name,
    color: libInfo.color.slice(1),
    logo: libInfo.logo || libInfo.logoURL.split('mobi/')[1],
    editor: libInfo.editor,
    cover: libInfo.cover || libInfo.coverURL.split('mobi/')[1],
    tips: libInfo.tips,
    icon: libInfo.provider_icon || libInfo.provider_iconURL.split('mobi/')[1],
    provider_appid,
    provider_name: libInfo.provider_name,
    grades: levels.join(','),
    action: 'random',
  }
}
export const reportFormatter = report => {
  return {
    gameNumber: report.gameNumber,
    perUserGames: report.perUserGames.toFixed(2) * 100,
    randomGameNumber: report.randomGameNumber,
    randomGameRate: report.randomGameRate.toFixed(0),
    userNumber: report.userNumber,
  }
}

/**
 * ========== libQuestion ==========
 */
export const questionFormatter = function(question) {
  const formatStatus = status => {
    switch (status) {
      case 0:
        return '待审核'
      case 1:
        return '已发布'
      case -1:
        return '审核不通过'
    }
  }
  const updatedTime = moment(question.updatedTime).format('YYYY.MM.DD HH:mm:ss')
  /** @namespace question.answers */
  const filter = function(id) {
    let e = question.answers.filter(item => item.id === id)[0]
    if (e) {
      return e.text || ''
    } else {
      return ''
    }
  }
  return {
    question: question.text,
    answer: filter(0),
    distracter1: filter(1),
    distracter2: filter(2),
    distracter3: filter(3),
    id: question.id,
    tag: question.tag,
    updatedTime,
    displayStatus: formatStatus(question.status),
  }
}
export const stringifyQuestion = function(question) {
  return {
    id: question.id,
    question: question.question,
    answer: question.answer,
    distracter1: question.distracter1,
    distracter2: question.distracter2,
    distracter3: question.distracter3 || '',
    tag: question.tag || '',
  }
}
export const questionsFormatter = function(list) {
  return list.map(question => {
    return questionFormatter(question)
  })
}

/**
 * ========== libAward ==========
 */
export const awardFormatter = function(award) {
  const displayFrequency = award.frequency === 1 ? '一天' : '累计'
  const getDisplayTrigger = (trigger, steps, displayFrequency) => {
    switch (trigger) {
      case 0:
        return '手动抽奖'
      case 1:
        if (award.isSample) {
          return '一天 / 累计参加 ___ 场比赛'
        } else {
          return `${displayFrequency}进行 ${steps} 场比赛`
        }

      case 2:
        return `${displayFrequency}与好友对战 ${steps} 场`
      case 3:
        return `题库排行榜中排名前 ${steps} 名`
      case 4:
        return `${displayFrequency}闯关成功 ${steps} 次`
      case 5:
        if (award.isSample) {
          return '累计与 ___ 位不同好友对战'
        } else {
          return `${displayFrequency}与 ${steps} 位不同好友对战`
        }
      case 6:
        if (award.isSample) {
          return '连续 ___ 天每天至少参加 1 场比赛'
        } else {
          return `连续 ${steps} 天每天参与至少一场比赛`
        }
    }
  }
  const getDateTimeStamp = ts => {
    const date = moment(ts).format('YYYY-MM-DD')
    return moment(date, 'YYYY-MM-DD').valueOf()
  }
  const getDisplayTime = ts => {
    if (ts === 'sample') {
      return '-'
    } else {
      return moment(ts).format('YYYY 年 M 月 D 日 HH:mm')
    }
  }
  const getIndicatorStatus = award => {
    const now = new Date().getTime()
    if (award.isSample) {
      return ''
    } else if (now < award.startDate) {
      return 'toStart'
    } else if (now < award.endDate) {
      return 'onGoing'
    } else {
      return 'finished'
    }
  }
  const getSampleType = award => {
    if (!award.isSample) {
      return ''
    }
    switch (award.trigger) {
      case 1:
        return '促进活跃: '
      case 5:
        return '促进用户分享: '
      case 6:
        return '促进活跃: '
      default:
        return ''
    }
  }
  const displayTrigger = getDisplayTrigger(
    award.trigger,
    award.steps,
    displayFrequency,
  )
  return {
    id: award.id,
    award: award.award, // 奖品名
    startTime: award.startDate, // 开始时间
    displayStartTime: getDisplayTime(award.startDate),
    startDate: getDateTimeStamp(award.startDate),
    endTime: award.endDate, // 结束时间
    displayEndTime: getDisplayTime(award.endDate),
    endDate: getDateTimeStamp(award.endDate),
    finalTime: award.finalDate, // 领奖时间
    displayFinalTime: getDisplayTime(award.finalDate),
    finalDate: getDateTimeStamp(award.finalDate),
    indicatorStatus: getIndicatorStatus(award),
    fetched: award.fetchedAmounts || 0,
    amounts: award.amounts || '', // 奖品数量，不填则是不限量
    /**
     * 领奖频率
     * values: [0, 1, 2]
     * 0: 仅一次
     * 1: 每天可以领奖一次
     * 2: 定时, 到达截止日期可以领取一次
     */
    frequency: award.frequency, // 领奖频率： 0: 达到就领 1: 每天一次，达到就领 2: 暂不用
    displayFrequency,
    status: award.status, // 上下线，暂时不用处理
    /**
     * 获奖方式
     * 0 : 无主动触发
     * 1 : 进行 x 场比赛
     * 2 : 与好友对战 x 次
     * 3 : 在排行榜前 x 名 (暂不可用)
     * 4 : 闯关成功 x 次 (暂不可用)
     * 5 : 与 x 位不同好友对战
     * 6 : 连续 x 天完成至少 1 次比赛
     */
    trigger: award.trigger,
    displayTrigger,
    steps: award.steps || '', // 可选，上一个参数中的变量 x
    tip: award.tip || '点击领取奖励 >', // 客户端领奖页的跳转链接文案
    isSample: award.isSample,
    sampleType: getSampleType(award),
  }
}
export const generateDefaultAward = function() {
  const startTime = moment().add(3, 'days')
  const endTime = moment().add(10, 'days')
  return {
    award: '',
    amounts: 10,
    startDate: new Date(
      moment(startTime.format('YYYY-MM-DD'), 'YYYY-MM-DD').valueOf(),
    ),
    startHourMin: '00:00',
    startTime: startTime.valueOf(),
    endDate: new Date(
      moment(endTime.format('YYYY-MM-DD'), 'YYYY-MM-DD').valueOf(),
    ),
    endHourMin: '00:00',
    endTime: endTime.valueOf(),
    trigger: 1,
    frequency1: 1,
    displayFrequency1: '一天',
    steps1: 1,
    frequency2: 0,
    displayFrequency2: '累计',
    steps2: 5,
    frequency5: 0,
    displayFrequency5: '累计',
    steps5: 5,
    frequency6: 0,
    steps6: 7,
    dealDays: 10,
    tip: '点击领取奖励 >', // 客户端领奖页的跳转链接文案
  }
}
export const generateSampleAward = function(trigger) {
  let type = parseInt(trigger)
  const getSteps = () => {
    switch (type) {
      case 1:
        return 1
      case 6:
        return 7
      case 5:
        return 1
    }
  }
  const getFrequency = () => {
    switch (type) {
      case 1:
        return 1
      case 6:
        return 0
      case 5:
        return 1
    }
  }
  return {
    action: 'address',
    amounts: '',
    award: '',
    endDate: 'sample',
    finalDate: 'sample',
    frequency: getFrequency(),
    startDate: 'sample',
    steps: getSteps(),
    tip: '点击领取奖励 >',
    trigger: type,
    isSample: true,
  }
}
export const combineAward = (defaultAward, formattedAward) => {
  let award = {
    id: formattedAward.id,
    award: formattedAward.award,
    amounts: formattedAward.amounts,
    startDate: new Date(
      moment(
        moment(formattedAward.startTime).format('YYYY-MM-DD'),
        'YYYY-MM-DD',
      ).valueOf(),
    ),
    startHourMin: moment(formattedAward.startTime).format('HH:mm'),
    startTime: formattedAward.startTime,
    endDate: new Date(
      moment(
        moment(formattedAward.endDate).format('YYYY-MM-DD'),
        'YYYY-MM-DD',
      ).valueOf(),
    ),
    endHourMin: moment(formattedAward.startTime).format('HH:mm'),
    endTime: formattedAward.endDate,
    trigger: formattedAward.trigger,
    frequency1: 0,
    displayFrequency1: '累计',
    steps1: '',
    frequency2: 0,
    displayFrequency2: '累计',
    steps2: '',
    frequency5: 0,
    displayFrequency5: '累计',
    steps5: '',
    frequency6: 0,
    steps6: '',
    dealDays: 10,
    tip: '点击领取奖励 >', // 客户端领奖页的跳转链接文案
  }
  // 处理 trigger 与 frequency 等的关系
  award[`frequency$${award.trigger}`] = formattedAward.frequency
  award[`displayFrequency${award.trigger}`] = formattedAward.displayFrequency
  award[`steps${award.trigger}`] = formattedAward.steps
  // 计算 dealDays
  award.dealDays = Math.round(
    (formattedAward.finalTime - formattedAward.endTime) / 3600000 / 24,
  )
  return award
}
export const stringifyAward = function(award) {
  // 时间合成器:
  const timeFormatter = function(dateObject, displayTime) {
    const [hour, minute] = displayTime.split(':')
    return dateObject.getTime() + hour * 60 * 60 * 1000 + minute * 60 * 1000
  }
  const getFrequency = award => {
    if (
      award[`frequency${award.trigger}`] === 0 ||
      award[`frequency${award.trigger}`] === 1
    ) {
      return award[`frequency${award.trigger}`]
    }
  }
  return {
    award: award.award,
    trigger: award.trigger,
    frequency: getFrequency(award),
    steps: award[`steps${award.trigger}`] || '',
    action: 'address', // 领奖的操作，暂时只支持填写地址领取实物奖品，填写 address 会调出填写用户地址 Form
    action_tip: award.tip, // 点击领奖处的文案，暂时是只支持一种 '点击领取奖励 >', 在生成默认 award 时写死了。
    start_date: moment(
      timeFormatter(award.startDate, award.startHourMin),
    ).valueOf(),
    end_date: moment(timeFormatter(award.endDate, award.endHourMin)).valueOf(),
    final_date: moment(timeFormatter(award.endDate, award.endHourMin))
      .add(award.dealDays, 'days')
      .valueOf(),
    amounts: award.amounts || '',
  }
}

// export const newAwardFormatter = function (award) {
// }

/**
 * ========== provider ==========
 */
export const providerFormatter = function(event) {
  /* eslint-disable */
  const backProviderModel = {
    id: 38656,
    status: 1,
    launchTime: 0,
    updateTime: 0,
    packageName: 'org.wandoujia.mp.3070679657',
    appName: '轻芒微阅读',
    channel: '轻芒微阅读',
    tagline: '一个青年的修行和他庸常的故事',
    iconRgb: 0,
    icon:
      'http://img.qingmang.mobi/image/orion/ca52a3ad079ce16ef5610ca59104a0d_640_640.jpeg',
    url: '',
  }
  const feModel = {
    id: 38656,
    status: 1,
    launchTime: 0,
    updateTime: 0,
    packageName: 'org.wandoujia.mp.3070679657',
    appName: '轻芒微阅读',
    channel: '轻芒微阅读',
    tagline: '一个青年的修行和他庸常的故事',
    iconRgb: 0,
    icon:
      'http://img.qingmang.mobi/image/orion/ca52a3ad079ce16ef5610ca59104a0d_640_640.jpeg',
    url: '',
  }
  /* eslint-enable */
  return event.provider
}
/**
 * ========== article ==========
 */
/* eslint-disable */
export function formatTime(n) {
  let h = 0
  let s = Math.floor(n % 60) || '00'
  let m = Math.floor(n / 60) || '00'
  if (m > 59) {
    h = Math.floor(m / 60) || '00'
    m = m % 60 || '00'
  }
  let result = [h, m, s].map(function(e) {
    e = String(e)
    if (e.length < 2) {
      e = '0' + e
    }
    return e
  })
  if (result[0] === '00') {
    result = result.slice(1)
  }
  return result.join(':')
}

export function articleEventFormatter(event) {
  // 付费标识 - 通用链接 文章
  if (event && event.type === 'article') {
    const isAudio = [
      () => event.article.contentType === 'audio',
      () => event.article.musics && event.article.musics.length,
    ].every(fn => fn())
    let editorId = ''
    if (['original', 'pay'].indexOf(event.article.copyrightType) >= 0) {
      const url = Sea.url(event.article.webUrl)
      editorId = url.path.split('/').slice(-1)[0]
    }
    return {
      packageName: event.article.packageName,
      editorId: editorId,
      isAudio: isAudio,
      contentType: event.article.contentType,
      duration: isAudio ? formatTime(event.article.musics[0].duration) : '',
      docId: event.article.docIdString,
      title: event.article.title,
      mid: event.article.mid || 0,
      magazineName: event.article.magazineName || '',
      snippet: event.article.snippet || '',
      providerName: event.article.appName,
      // cover: {url, height, width}
      cover: event.article.covers[0] || event.article.images[0] || null,
      hero: event.article.hero || null,
      providerIcon: event.article.appIcon || '',
      providerId: qm.get(event, 'article.appChannels[0].id') || '',
      publishDate: event.article.publishDate,
      displayPublishDate: event.article.publishDate
        ? qm.getRelatedFormattedTime(event.article.publishDate)
        : '-',
      isSelected: event.isSelected,
      isPinned: event.isPinned,
      markCount: event.markCount,
      topicCount: event.topicCount,
      shareCount: event.shareCount,
    }
  } else {
    return null
  }
}
export function cubitaEventFormatter(article) {
  // 付费标识 - 通用链接 文章
  let selected = (article.columns || []).map(column => {
    return {
      needPay: column.isPremium,
      name: column.name,
      id: column.id,
      listID: column.listId,
    }
  })
  return {
    isCubita: true,
    needPay: article.publishStrategy === 'protect',
    ...article,
    editorId: article.id,
    docId: article.docId,
    title: article.title || '无标题',
    date:
      article.status === 'draft'
        ? '-'
        : moment(article.publishedTime).format('YYYY-MM-DD HH:mm'),
    selected,
  }
}

/* eslint-enable */

/**
 * ========== user ==========
 */
/* eslint-disable */
const userEvent = {
  timestamp: 1468570640573,
  type: 'user',
  style: 'normal',
  isMarked: false,
  isRead: false,
  isPinned: false,
  isSelected: false,
  showItemHeader: true,
  markCount: 0,
  commentCount: 0,
  topicCount: 0,
  postCount: 0,
  shareCount: 0,
  fromXiaohua: false,
  history: false,
  user: {
    uid: 7,
    type: 1,
    name: 'gronghua',
    avatar:
      'http://statics03.qingmang.mobi/image/proxy/aHR0cHMlM0EvL3d4LnFsb2dvLmNuL21tb3Blbi92aV8zMi9RMGo0VHdHVGZUS3VCc2dOZWxEOHpHRzJFakZ6V0NiS1ZHdlliaWF1SWhWQjg1bDA2SFJGSTNHSUk5SHVXRXRMN2lhdVBKaHVnUmljaWJMRFJlTnprNFQ1MGcvMTMy',
    desc: '篮球爱好者~~爱生活，爱轻芒(*芳)~~~',
    relation: 'none',
    updatedTimestamp: 1468570640573,
    role: {
      type: 'member',
      status: 'blocked',
    },
    articles: [],
    magazines: [],
  },
}
/* eslint-enable */
export const userFormatter = function(event) {
  const {uid, name, avatar, desc, updatedTimestamp, role} = event.user
  const {markCount, commentCount, topicCount, postCount, shareCount} = event
  return {
    uid,
    name,
    avatar,
    desc,
    updatedTimestamp,
    updatedTime: qm.getDateTime(updatedTimestamp),
    role,
    markCount,
    commentCount,
    topicCount,
    postCount,
    shareCount,
  }
}

/**
 * ========== comment post note ==========
 */
export const commentEventsFormatter = event => {
  /* eslint-disable */
  const BEModel = {
    timestamp: 1528443264000,
    type: 'comment',
    post: {
      id: 24301,
      uid: 3391389,
      mid: 44294,
      nid: 12008336,
      docId: 7817730071491680683,
      entityId: 7817730071491680683,
      postType: 'noteWithAT',
      isPin: false,
      isFree: false,
      isDeleted: false,
      isPreview: false,
      user: {
        uid: 3391389,
        type: 2,
        name: 'gronghua',
        avatar:
          'http://statics03.qingmang.mobi/image/proxy/aHR0cHMlM0EvL3d4LnFsb2dvLmNuL21tb3Blbi92aV8zMi9RMGo0VHdHVGZUTFlaVFFFYWZqWmpWTnFqN0lrdmliY3dJY2lhelRjYWVYVHB2RWlhanVqWjJxeVBqV3V6ajcwTUtORldrMEFnOGpqeEU3d0FBaWJLaFVoY3cvMA==',
        relation: 'none',
        updatedTimestamp: 1513770299122,
        articles: [],
        magazines: [],
      },
      note: {
        nid: 12008336,
        uid: 3391389,
        firstNoteUid: 0,
        cid: 0,
        mid: 44294,
        magazineName: '轻芒工作群',
        docId: 7817730071491680683,
        noteType: 'highlight',
        contentType: 'article',
        content:
          '[{"nodecontent":"{\\"id\\":\\"24a3\\",\\"type\\":0,\\"text\\":{\\"text\\":\\"A：你必须把 qingmang@wandoujia.com 这个邮箱添加到你的「认可的电子邮箱」列表里。同样的，添加的位置是「管理我的内容和设备」-「设置」-「个人文档设置」。\\"}}","start":0,"end":52,"id":"24a3"}]',
        annotation: '哈哈哈哈',
        isDeleted: false,
        isImage: false,
        weight: 100,
        createdTimestamp: 1527836732000,
        updatedTimestamp: 1527836732000,
        user: {
          uid: 3391389,
          type: 2,
          name: 'gronghua',
          avatar:
            'http://statics03.qingmang.mobi/image/proxy/aHR0cHMlM0EvL3d4LnFsb2dvLmNuL21tb3Blbi92aV8zMi9RMGo0VHdHVGZUTFlaVFFFYWZqWmpWTnFqN0lrdmliY3dJY2lhelRjYWVYVHB2RWlhanVqWjJxeVBqV3V6ajcwTUtORldrMEFnOGpqeEU3d0FBaWJLaFVoY3cvMA==',
          relation: 'none',
          articles: [],
          magazines: [],
        },
        article: {
          docId: 7817730071491680683,
          docIdString: '7817730071491680683',
          cid: 0,
          mid: 0,
          interestId: 0,
          title: 'Q&A：一份关于「轻芒阅读周刊」的答疑',
          isRecommend: false,
          covers: [],
          images: [],
          videos: [],
          musics: [],
          tags: [],
          contentHtmlLength: 0,
          contentLength: 0,
          publishDate: 0,
          docDate: 0,
          keywords: [],
          appChannels: [],
        },
        highlightLength: 52,
        stat: {},
        similarCount: 0,
        relation: {},
        createTimeDebug: 'Some(2018-06-01 15:05:32.0)',
        updateTimeDebug: '2018-06-01 15:05:32.0',
        highlights: [
          {
            start: 0,
            end: 52,
            id: '24a3',
            content: {
              id: '24a3',
              type: 0,
              text: {
                text:
                  'A：你必须把 qingmang@wandoujia.com 这个邮箱添加到你的「认可的电子邮箱」列表里。同样的，添加的位置是「管理我的内容和设备」-「设置」-「个人文档设置」。',
              },
            },
          },
        ],
      },
      mark: {
        id: 0,
        mockId: 'n12008336_24a3',
        docId: 7817730071491680683,
        docIdString: '7817730071491680683',
        pid: '24a3',
        start: 0,
        end: 52,
        type: 'text',
        title: 'Q&A：一份关于「轻芒阅读周刊」的答疑',
        content:
          'A：你必须把 qingmang@wandoujia.com 这个邮箱添加到你的「认可的电子邮箱」列表里。同样的，添加的位置是「管理我的内容和设备」-「设置」-「个人文档设置」。',
        status: 'NORMAL',
        updatedTime: 1527836732000,
        count: 1,
        notes: [],
        isMarked: false,
        cid: 0,
        mid: 0,
        nid: 12008336,
      },
      reviewStatus: 'needApproval',
      createdTimestamp: 1527836742000,
      updatedTimestamp: 1527836742000,
    },
    comment: {
      id: 3609,
      uid: 6117669,
      targetId: '24301',
      targetType: 'post',
      referenceId: 0,
      magazineId: 44294,
      content: '……',
      contentType: 'text',
      status: 1,
      reviewStatus: 'approved',
      appId: 'wxa988d598f9614e68',
      platform: 'life_mina',
      createdTime: 1528443264000,
      updatedTime: 1528443264000,
    },
    isMarked: false,
    isRead: false,
    isPinned: false,
    isSelected: false,
    showItemHeader: false,
    markCount: 0,
    commentCount: 0,
    topicCount: 0,
    postCount: 0,
    shareCount: 0,
    fromXiaohua: false,
    history: false,
  }
  /* eslint-enable */
  const parseImages = event => {
    if (event.type === 'comment') {
      return event.comment.contentType !== 'image' ? [] : [event.comment.content]
    } else if (event.type === 'post') {
      return event.post.images
    } else if (event.type === 'note') {
      return event.note.annotation.images
    }
  }
  const parseContent = event => {
    if (event.type === 'comment') {
      return event.comment.contentType !== 'image' ? event.comment.content : ''
    } else if (event.type === 'post') {
      return event.post.content
    } else if (event.type === 'note') {
      return event.note.annotation.text
    }
  }
  const parseAuthor = event => {
    if (event.type === 'comment') {
      if (event.comment.userInfo) {
        return {
          author: event.comment.userInfo.name,
          authorId: event.comment.userInfo.uid,
          authorAvatar: event.comment.userInfo.avatar,
        }
      }
      return {
        author: event.comment.user.name,
        authorId: event.comment.user.uid,
        authorAvatar: event.comment.user.avatar,
      }
    } else if (event.type === 'post') {
      return {
        author: event.post.user.name,
        authorId: event.post.uid,
        authorAvatar: event.post.user.avatar,
      }
    } else if (event.type === 'note') {
      return {
        author: event.note.user.name,
        authorId: event.note.user.uid,
        authorAvatar: event.note.user.avatar,
      }
    }
  }
  const parseReferenceTopic = event => {
    const result = {}
    if (event.type === 'comment') {
      if (event.post && event.post.note) {
        result.content = event.post.note.annotation
      } else if (event.post) {
        result.content = event.post.content
        result.images = event.post.images
      }
    } else if (event.type === 'note') {
      if (event.note.topic) {
        result.content = event.note.topic.title
      }
    }
    return result
  }
  const parseReferenceComment = event => {
    const result = {}
    if (event.type === 'comment') {
      if (event.comment.referenceComment) {
        result.author = event.comment.referenceComment.user
        if (event.comment.referenceComment.contentType === 'text') {
          result.type = 'text'
          result.content = event.comment.referenceComment.content
        } else {
          result.type = 'image'
          result.image = event.comment.referenceComment.content
        }
      } else if (event.comment.referrerUser) {
        result.author = event.comment.referrerUser
      }
    }
    return result
  }
  const parseReferenceArticle = event => {
    const article = {}
    if (event.post) {
      if (event.post.note) {
        article.cover = event.post.note.article.cover
        article.title = event.post.note.article.title
        article.snippet = event.post.note.article.snippet
        article.docIdString = event.post.note.article.docIdString
      } else if (event.post.article) {
        article.cover = event.post.article.cover
        article.title = event.post.article.title
        article.snippet = event.post.article.snippet
        article.docIdString = event.post.article.docIdString
      }
    } else if (event.note && event.note.docIdString) {
      article.docIdString = event.note.docIdString
      article.cover = event.note.cover
      article.title = event.note.title
      article.snippet = event.note.snippet
      article.docIdString = event.note.docIdString
    }
    return article
  }
  const parseReferenceMarks = event => {
    const marks = []
    if (event.note && event.note.marks) {
      for (let markContent of event.note.marks) {
        let parsedContent = JSON.parse(markContent.nodecontent)
        let mark = {
          type: parsedContent.type
        }
        if (mark.type === 0) {
          if (mark.end > mark.start) {
            mark.content = parsedContent.text.text.substring(markContent.start, markContent.end)
          } else {
            mark.content = parsedContent.text.text
          }
        } else if (mark.type === 1) {
          mark.content = parsedContent.image.source
        }
        marks.push(mark)
      }
    }
    return marks
  }
  const parseCreatedTime = event => {
    if (event.type === 'comment') {
      return qm.getDateTime(event.comment.createdTime)
    } else if (event.type === 'note') {
      return qm.getDateTime(event.note.createdTime)
    } else {
      return qm.getDateTime(event.post.createdTimestamp)
    }
  }
  const parseStatus = event => {
    if (event.type === 'comment') {
      return event.comment.reviewStatus
    } else if (event.type === 'note') {
      return event.note.review_status
    } else {
      return event.post.reviewStatus
    }
  }
  const parseId = event => {
    if (event.type === 'comment') {
      return event.comment.id
    } else if (event.type === 'note') {
      return event.note.id
    } else {
      return event.post.id
    }
  }
  const parseMagazineId = event => {
    if (event.type === 'comment') {
      return event.comment.magazineId
    } else if (event.type === 'note') {
      return null
    } else {
      return event.post.mid
    }
  }

  return {
    id: parseId(event),
    type: event.type,
    images: parseImages(event),
    content: parseContent(event),
    author: parseAuthor(event).author,
    authorId: parseAuthor(event).authorId,
    authorAvatar: parseAuthor(event).authorAvatar,
    referenceTopic: parseReferenceTopic(event),
    referenceArticle: parseReferenceArticle(event),
    referenceComment: parseReferenceComment(event),
    referenceMarks: parseReferenceMarks(event),
    createdTime: parseCreatedTime(event),
    status: parseStatus(event),
    magazineId: parseMagazineId(event),
    note: event.note
  }
}
/* eslint-disable */
/**
 * ========== magazine ==========
 */
/* eslint-disable */
const backEndMagazineConfigModel = {
  providerIds: {
    // 杂志绑定的 providerId, 类型是 map
    '2683': 'subscribed',
    '3422': 'subscribed',
  },
  autoPick: true, // 杂志的文章是是否自动更新, 类型是 Boolean 如：true/false
  needRelated: true, // 是否需要相关文章, 类型是 Boolean 如：true/false
  showStatistics: true, // 是否展示杂志的统计信息, 类型是 Boolean 如：true/false
  enableComment: true, // 是否打开评论功能, 类型是 Boolean 如：true/false
  showItemHeader: true, // 是否显示 timeline 中每个卡片的头部信息, 类型是 Boolean 如：true/false
  showPostFromContributorsOnly: true, // 是否只显示主编发的帖子, 类型是 Boolean 如：true/false
  instructionContent: 'text', //杂志的使用说明，类型是字符串或者图片链接 imageUrl/text
  tabs: [
    {
      type: 'selected',
      name: '精选',
      defaultSelected: false,
    },
  ], //页面展示的 tabs，类型是 tab model 的列表，目前支持 4 种类型的 tab: intro/selected/latest/group，
  showCommentSize: 10, // timeline 每个 event 下展示评论的数量,类型是 Int,如：30
  basicConfig: {
    //杂志的基本配置：model 如下：
    maxAdminCount: 0,
    maxContributorCount: 0,
    maxMemberCount: 0,
    adminCopy: '管理员',
    contributorCopy: '编辑',
    memberCopy: '成员',
    postConfig: {
      article: 'optional',
      image: 'optional',
      video: 'optional',
      content: 'optional',
      vote: 'optional',
      lottery: 'optional',
    },
    discussConfig: {
      article: 'optional',
      image: 'optional',
      content: 'optional',
    },
  },
  permissionConfig: {
    adminConfig: {
      canManageMember: true,
      canManageSource: true,
      canPost: true,
      canDiscuss: true,
      canComment: true,
      canRead: true,
    },
    contributorConfig: {
      canManageMember: false,
      canManageSource: true,
      canPost: true,
      canDiscuss: true,
      canComment: true,
      canRead: true,
    },
    memberConfig: {
      canManageMember: false,
      canManageSource: false,
      canPost: true,
      canDiscuss: true,
      canComment: true,
      canRead: true,
    },
    strangerConfig: {
      canManageMember: false,
      canManageSource: false,
      canPost: false,
      canDiscuss: false,
      canComment: false,
      canRead: false,
    },
  },
}
/* eslint-enable */
export const magazineConfigEventFormatter = function(event) {
  let m = qm.deepCopy(event.magazineConfig)
  const defaultPermissionConfig = {
    adminConfig: {
      canManageMember: true,
      canManageSource: true,
      canPost: true,
      canDiscuss: true,
      canComment: true,
      canRead: true,
    },
    contributorConfig: {
      canManageMember: false,
      canManageSource: true,
      canPost: true,
      canDiscuss: true,
      canComment: true,
      canRead: true,
    },
    memberConfig: {
      canManageMember: false,
      canManageSource: false,
      canPost: false,
      canDiscuss: true,
      canComment: true,
      canRead: true,
    },
    strangerConfig: {
      canManageMember: false,
      canManageSource: false,
      canPost: false,
      canDiscuss: false,
      canComment: false,
      canRead: true,
    },
  }
  const discussConfigFormatter = discussConfig => {
    if (
      discussConfig.image === 'optional' &&
      discussConfig.content === 'optional'
    ) {
      return 'image&text'
    } else if (discussConfig.content === 'optional') {
      return 'text'
    } else if (discussConfig.image === 'optional') {
      return 'image'
    }
  }
  const descriptionTypeFormatter = magazine => {
    if (
      magazine.desc &&
      magazine.desc.startsWith('http://statics01.readland.cn/')
    ) {
      return 'image'
    } else if (magazine.desc) {
      return 'text'
    } else {
      return 'none'
    }
  }
  return {
    id: m.magazine.id,
    isOn: m.magazine.isOn,
    isPreview: m.magazine.isPreview,
    basicConfig: {
      id: m.magazine.id,
      name: m.magazine.name,
      subTitle: m.magazine.alias,
      color: '#' + m.magazine.color,
      cover: m.magazine.cover || '',
      descriptionType: descriptionTypeFormatter(m.magazine), // values: ['none', 'text', 'image']
      desc:
        m.magazine.desc &&
        m.magazine.desc.startsWith('http://statics01.readland.cn/')
          ? ''
          : m.magazine.desc,
      descImage:
        m.magazine.desc &&
        m.magazine.desc.startsWith('http://statics01.readland.cn/')
          ? m.magazine.desc
          : '',
    },
    personalityConfig: {
      style: m.magazine.style,
      sort: m.feedRankType,
      autoPick: m.autoPick || false,
      showPostFromContributorsOnly: m.showPostFromContributorsOnly,
      showItemHeader: false,
      showItemFooter: m.cardFooterStyle,
      // 阅读更多
      needRelated: m.needRelated,
      needRelatedMagazine: m.needRelatedMagazine,
      needRelatedArticle: m.needRelatedArticle,
      adminCopy: m.basicConfig ? m.basicConfig.adminCopy : '',
      contributorCopy: m.basicConfig ? m.basicConfig.contributorCopy : '',
      memberCopy: m.basicConfig ? m.basicConfig.memberCopy : '',
    },
    shareConfig: {
      type: 'magazine', // 分享配置的类型，默认 magazine
      title: m.shareConfig ? m.shareConfig.title : '',
      image: m.shareConfig ? m.shareConfig.image : '', // 分享图片
      poster: m.shareConfig ? m.shareConfig.poster : '', // 分享海报
      uri: m.shareConfig ? m.shareConfig.uri : '', // 可以定制的分享路径
    },
    permissionConfig: _.merge(defaultPermissionConfig, m.permissionConfig),
    discussConfig: {
      // 判断是否评论需要经过审核 不需要审核： approved， 需要： needApproval
      ugcReviewStatus: m.ugcReviewStatus === 'needApproval',
      // 是否打开评论功能, 类型是 Boolean 如：true/false
      enableComment: m.enableComment || false,
      // 回复文章评论时，可发的内容 values: ['image&text', 'text', 'image']
      replyConfig:
        m.basicConfig && m.basicConfig.discussConfig
          ? discussConfigFormatter(m.basicConfig.discussConfig)
          : discussConfigFormatter({
              article: 'optional',
              image: 'optional',
              content: 'optional',
            }),
    },
    tabs: m.tabs,
    // 默认设置为 protect ，即不会让他加入会员，不显示 加入群组的功能。
    enterAction: m.enterAction || {
      type: 'protect',
      products: [],
    },
    aboutPageId: m.aboutPageId,
    oldConfig: event.magazineConfig,
  }
}
export const magazineConfigStringifier = function(magazineConfig) {
  let fm = qm.deepCopy(magazineConfig) // FE Magazine Model
  const discussConfigStringifier = replyConfig => {
    if (replyConfig === 'image&text') {
      return {
        article: 'optional',
        image: 'optional',
        content: 'optional',
      }
    } else if (replyConfig === 'image') {
      return {
        article: 'optional',
        image: 'optional',
        content: 'forbidden',
      }
    } else if (replyConfig === 'text') {
      return {
        article: 'optional',
        image: 'forbidden',
        content: 'optional',
      }
    }
  }
  const descStringifier = basicConfig => {
    if (basicConfig.descriptionType === 'image') {
      return basicConfig.descImage
    } else if (basicConfig.descriptionType === 'text') {
      return basicConfig.desc
    } else {
      return ''
    }
  }
  /**
   * tabs 的编辑器，做了一些特殊处理:
   * 空 tabs 会根据有没有 intro 塞 latest 进去
   */
  const tabsStringifier = magazineConfig => {
    const basicConfig = magazineConfig.basicConfig
    const tabs = magazineConfig.tabs.filter(tab => {
      return tab.type !== 'intro'
    })
    if (tabs.length === 0) {
      tabs.push({
        type: 'latest',
        name: '阅读',
        defaultSelected: true,
      })
    }
    if (basicConfig.descriptionType !== 'none') {
      tabs.unshift({
        type: 'intro',
        name: '简介',
        defaultSelected: false,
      })
    }
    return tabs
  }
  const options = {
    autoPick: fm.personalityConfig.autoPick,
    enableComment: fm.discussConfig.enableComment,
    showItemHeader: fm.personalityConfig.showItemHeader,
    feedRankType: fm.personalityConfig.sort,
    cardFooterStyle: fm.personalityConfig.showItemFooter,
    needRelated: fm.personalityConfig.needRelated,
    needRelatedMagazine: fm.personalityConfig.needRelatedMagazine,
    needRelatedArticle: fm.personalityConfig.needRelatedArticle,
    basicConfig: {
      adminCopy: fm.personalityConfig.adminCopy,
      contributorCopy: fm.personalityConfig.contributorCopy,
      memberCopy: fm.personalityConfig.memberCopy,
      discussConfig: discussConfigStringifier(fm.discussConfig.replyConfig),
    },
    permissionConfig: fm.permissionConfig,
    showPostFromContributorsOnly:
      fm.personalityConfig.showPostFromContributorsOnly,
    ugcReviewStatus: fm.discussConfig.ugcReviewStatus
      ? 'needApproval'
      : 'approved',
    magazine: {
      name: fm.basicConfig.name,
      alias: fm.basicConfig.subTitle,
      color: fm.basicConfig.color.substring(1, 7),
      cover: fm.basicConfig.cover,
      desc: descStringifier(fm.basicConfig),
      style: fm.personalityConfig.style,
    },
    shareConfig: fm.shareConfig,
    tabs: tabsStringifier(fm),
    enterAction: fm.enterAction,
    aboutPageId: fm.aboutPageId,
  }
  return Object.assign(magazineConfig.oldConfig, options)
}
export const magazineInfoEventFormatter = function(event) {
  if (!event || !event.magazineInfo || !event.magazineInfo.magazine) {
    return { id: '', name: '', logo: undefined, cover: '', desc: '', curators: [], color: '#ACACAC' }
  }
  return {
    id: event.magazineInfo.magazine.id,
    logo: event.magazineInfo.magazine.logo || undefined,
    name: event.magazineInfo.magazine.name,
    cover: event.magazineInfo.magazine.cover || '',
    desc: event.magazineInfo.magazine.desc || '',
    curators: (event.magazineInfo.curators || []).map(userFormatter),
    color: event.magazineInfo.magazine.color
      ? '#' + event.magazineInfo.magazine.color
      : '#ACACAC',
  }
}
export const magazineEventFormatter = function(column) {
  return {
    catalogs: column.catalogs || [],
    needPay: column.isPremium,
    id: column.id,
    name: column.name,
    cover: column.cover || '',
    desc: column.desc || '',
    status: column.status === 'online' ? 'online' : 'offline',
    color: column.color ? '#' + column.color : '#ACACAC',
  }
}
export const magazineRelationFormatter = function(magazineRelationEvent) {
  // TODO: 完成 relation formatter
  const e = magazineRelationEvent
  const typeFormatter = type => {
    switch (type) {
      case 'stranger':
        return '游客'
      case 'member':
        return '成员'
      case 'contributor':
        return '贡献者'
      case 'admin':
        return '管理员'
    }
  }
  return {
    type: e.user.role.type,
    magazineId: e.magazine.id,
    name: e.magazine.name,
    cover: e.magazine.cover || '',
  }
}
export const magazineDailyDataFormatter = function(event) {
  return event.magazineStatistics
}

/**
 * ========== Page ==========
 */
export const publicationPageEventFormatter = function(event) {
  let publicationPage = event.publicationPage || {}
  publicationPage.timeline = publicationPage.timeline || []
  publicationPage.idString = String(publicationPage.id || '')
  return publicationPage
}

export const topicFormatter = topic => {
  const {
    id,
    title,
    cover,
    content,
    type,
    deadline,
    options,
    maxVoting,
    organization,
    participantUsers,
    participantNumber,
    createdTime,
    textColor,
    backgroundColor,
    status
  } = topic
  const typeDic = {
    '1': 'collect',
    '2': 'vote',
    '3': 'discuss',
  }
  const displayTypeDic = {
    '1': '# 征集',
    '2': '# 投票',
    '3': '# 表态',
  }
  return {
    id,
    topicType: typeDic[type],
    displayTopicType: displayTypeDic[type],
    title,
    cover,
    content,
    organization,
    avatars:
      participantUsers && participantUsers.length
        ? participantUsers.map(user => user.avatar)
        : null,
    participantCount: participantNumber,
    displayCreatedTime: createdTime ? qm.getDateTime(createdTime) : '暂无时间',
    options,
    optionType: maxVoting === 1 ? 'single' : 'multi',
    displayDeadline: deadline ? qm.getDateTime(deadline) : null,
    backgroundColor,
    textColor,
    status,
  }
}
